<ifc-base-dialog title="Add liquidity event"
                 [actions]="actions"
                 (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <form [formGroup]="liquidityForm" class="form">
        <div fxLayout="column">
            <mat-form-field appearance="outline"
                ngClass.xs="form-field-xs"
                ngClass.gt-xs="form-field-md">
                <mat-label>Liquidity event</mat-label>
                <mat-select matInput
                    formControlName="resolutionStatus"
                    placeholder="Liquidity event"
                    >
                    <mat-option *ngFor="let option of resolutionStatusOptions" [value]="option.value">{{option.name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <ifc-datepicker [fc]="liquidityForm.get('resolutionDate')" [label]="'Date of outcome'" [disabled]="false"></ifc-datepicker>
        </div>
    </form>
  </ng-template>
</ifc-base-dialog>
